import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    seriesTree: [],
    loading: false,
    activeSeries: null
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SERIES_LOAD_START:
			return updateObject(state, { loading: true });
        case actionTypes.SERIES_LOAD_SUCCESS: 
			return updateObject(state, { loading: false, seriesTree: action.data.tree });
        case actionTypes.SERIES_LOAD_FAIL: 
			return updateObject(state, { loading: false });
        case actionTypes.SERIES_SET_ACTIVE: 
			return updateObject(state, { activeSeries: action.series });
        default: 
            return state;
    }
}

export default reducer;
